import React, { useContext } from 'react';
import { AppContext, useCurrencySymbols } from '@nile/components';
import { TextField, Spinner } from '@superops/ui-design-system';

export function ProratedAmount({ amount, loading }) {
  const { companyInfo } = useContext<any>(AppContext);

  const currencyCode = companyInfo?.currency || 'USD';
  const countryCode = companyInfo?.countryCode || 'US';

  const { currencySymbolWithCode } = useCurrencySymbols();

  if (loading)
    return <Spinner accessibilityLabel="Small spinner example" size="small" />;
  return (
    <TextField
      size="extrasmall"
      autoComplete="off"
      label="ProratedAmount"
      labelHidden
      value={amount}
      min={0}
      type="number"
      disabled
      suffix={currencySymbolWithCode}
    />
  );
}
